import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';
import store from './store';
import Routes from './router';
import './styles/main.css';

if (process.env.NODE_ENV !== 'production') {
  console.info('Looks like we are in development mode!');
}

ReactDOM.render(
  <GoogleOAuthProvider clientId={process.env.GOOGLE_CLIENT_ID}>
    <Provider store={store}>
      <Routes />
    </Provider>
  </GoogleOAuthProvider>,
  document.getElementById('root')
);
